export default {
      id: "depth-3-usage",
      viewBox: "0 0 76 15",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#depth-3",
      toString: function () {
        return this.url;
      }
    }